import { UiStorage } from '@experiences/util';
import type { User } from '@uipath/auth-react';

export default function setLastUsedOrganizationId(user: User) {
    UiStorage.setItem('lastUsedOrganizationId', user.profile.prt_id);
}
